export const pagesPaths = {
  home: '/home',
  surveys: '/surveys',
  documents: '/documents',
} as const;

export type PagesPathsKeys = keyof typeof pagesPaths;
